import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { FootPrintApiManager_ModuleContextService } from './FootPrintApiManager.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_log_notes_report_ComponentContextService {
  private readonly moduleContext: FootPrintApiManager_ModuleContextService;

  constructor(moduleContext: FootPrintApiManager_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'log_notes_report',
      type: ComponentType.report
    }
  }
}